module.exports = __webpack_public_path__ + "img/ghost.95c7ba94.svg";